<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">线下佣金总额 ￥<span class="num num-margin">{{ brokerage_count }}</span></div>
            <div class="name">线下已结佣金 ￥<span class="num num-margin">{{ priced }}</span></div>
          </div>
          <div class="iconfont icon-yongjin"></div>
        </div>
      </div>
      <div class="search acea-row row-between-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="点击搜索会员名称" v-model="screen.keyword" />
            <span class="iconfont icon-guanbi"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2"></div>
      </div>
      <div class="date-selection">
        <div class="date-selection-item" @click="startShowPopup">{{ screen.startTime ? screen.startTime : "选择开始日期"}}</div>
        <div class="date-selection-item date-selection-item-icon">-</div>
        <div class="date-selection-item" @click="endShowPopup">{{screen.endTime ? screen.endTime : "选择结束日期"}}</div>
      </div>
      <van-popup v-model="startShow" position="bottom">
        <van-datetime-picker
        v-model="startTime.currentDate"
        type="date"
        title="选择开始日期"
        :min-date="startTime.minDate"
        :max-date="startTime.maxDate"
        @confirm="getStartTime"
        @cancel="cancelStartTime"
      />
      </van-popup>
      <van-popup v-model="endShow" position="bottom">
        <van-datetime-picker
        v-model="endTime.currentDate"
        type="date"
        title="选择结束日期"
        :min-date="endTime.minDate"
        :max-date="endTime.maxDate"
        @confirm="getEndTime"
        @cancel="cancelEndTime"
      />
      </van-popup>
      
    </div>
    <div class="list">
      <div
        class="sortNav acea-row row-middle"
        :class="fixedState === true ? 'on' : ''"
      >
        <!-- <div class="sortItem" @click="sort('childCount')">
          团队排序
          <img src="@assets/images/sort1.png" v-if="childCount == 1" />
          <img src="@assets/images/sort2.png" v-if="childCount == 2" />
          <img src="@assets/images/sort3.png" v-if="childCount == 3" />
        </div> -->
        <div class="sortItem" @click="sort('numberCount')">
          金额排序
          <img src="@assets/images/sort1.png" v-if="numberCount == 1" />
          <img src="@assets/images/sort2.png" v-if="numberCount == 2" />
          <img src="@assets/images/sort3.png" v-if="numberCount == 3" />
        </div>
        <div class="sortItem" @click="sort('orderCount')">
          订单排序
          <img src="@assets/images/sort1.png" v-if="orderCount == 1" />
          <img src="@assets/images/sort2.png" v-if="orderCount == 2" />
          <img src="@assets/images/sort3.png" v-if="orderCount == 3" />
        </div>
      </div>
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(val, index) in spreadList"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="val.avatar" /></div>
            <div class="text">
              <div class="name line1">{{ val.nickname }}</div>
              <div>加入时间: {{ val.time }}</div>
            </div>
          </div>
          <!-- <div class="right">
            <div>
              <span class="font-color-red">{{ val.childCount || 0 }}</span> 人
            </div>
          </div> -->
          <div class="bottom acea-row row-between-wrapper">
            <div class="bottom-item">
              <div>个人：<span class='font-color-red'>{{val.orderCount ? val.orderCount : 0}}单 | {{val.numberCount ? val.numberCount : 0}} 元</span></div>
            </div>
            <!-- <div class="bottom-item text-right">
              <div>下级：<span class='font-color-red'>{{val.orderCount ? val.orderCount : 0}}单 | {{val.numberCount ? val.numberCount : 0}} 元</span></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadMoney } from "../../../api/user";
import Loading from "@components/Loading";

import DatetimePicker from 'vant/lib/datetime-picker';
import 'vant/lib/datetime-picker/style';

import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import "@assets/iconfont-custom/iconfont.css";



export default {
  name: "PromoterList",
  components: {
    Loading,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]:Popup
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 15,
        keyword: "",
        sort: "",
        startTime:"",
        endTime:""
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      brokerage_count:0,
      priced:0,
      startTime:{
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(),
      },
      endTime:{
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(),
      },
      startShow:false,
      endShow:false,
      selectStartTime:0,
      selectEndTime:0,
    };
  },
  mounted: function() {
    this.getSpreadUsers();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSpreadUsers();
    });
  },
  watch: {
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    }
  },
  methods: {
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    },
    getSpreadUsers: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getSpreadMoney(screen).then(
        res => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.data.list);
          that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.page = that.screen.page + 1;
          that.brokerage_count = res.data.brokerage_count ?  res.data.brokerage_count : 0;
          that.priced = res.data.priced ? res.data.priced : 0;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    sort: function(types) {
      let that = this;
      switch (types) {
        case "childCount":
          if (that.childCount == 2) {
            that.childCount = 1;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount DESC";
          } else if (that.childCount == 1) {
            that.childCount = 3;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount ASC";
          } else if (that.childCount == 3) {
            that.childCount = 2;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "";
          }
          break;
        case "numberCount":
          if (that.numberCount == 2) {
            that.numberCount = 1;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount DESC";
          } else if (that.numberCount == 1) {
            that.numberCount = 3;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount ASC";
          } else if (that.numberCount == 3) {
            that.numberCount = 2;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        case "orderCount":
          if (that.orderCount == 2) {
            that.orderCount = 1;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount DESC";
          } else if (that.orderCount == 1) {
            that.orderCount = 3;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount ASC";
          } else if (that.orderCount == 3) {
            that.orderCount = 2;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        default:
          that.screen.sort = "";
      }
    },
    // 获取时间
    getStartTime:function(val){
      let isStartTime = val.getTime();
      let isEndTime = 1.7976931348623157E+10308;

      this.startShow = false;

      if(this.selectEndTime){
        isEndTime = this.selectEndTime.getTime()
      }
      if(isStartTime > isEndTime){
        // this.screen.startTime = '请选择开始日期';
        return this.$dialog.error('开始时间不能大于结束时间');
      }
      
      this.selectStartTime = val;
      this.startTime.currentDate = val;
      this.screen.startTime = this.timeFormat(val);
      if(this.screen.startTime && this.screen.endTime && this.screen.endTime != '请选择结束日期'){
        this.spreadList = [];
        this.loaded = false;
        this.loading = false;
        this.screen.page = 1;
        this.getSpreadUsers();
      }
    },
    getEndTime:function(val){
      let isEndTime = val.getTime();
      let isStartTime = 0;
      this.endShow = false;
      if(this.selectStartTime){
        isStartTime = this.selectStartTime.getTime();
      }
      if(isStartTime > isEndTime){
        // this.screen.endTime = '请选择结束日期';
        return this.$dialog.error('开始时间不能大于结束时间');
      }
      this.selectEndTime = val;
      this.endTime.currentDate = val;
      this.screen.endTime = this.timeFormat(val);
      this.endShow = false;
      if(this.screen.startTime && this.screen.endTime && this.screen.startTime != '请选择开始日期'){
        this.spreadList = [];
        this.loaded = false;
        this.loading = false;
        this.screen.page = 1;
        this.getSpreadUsers();
      }
    },
    timeFormat(time) { // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + '-' + month + '-' + day;
    },
    // 弹出时间选择器
    startShowPopup() {
      this.startShow = true;
    },
    endShowPopup() {
      this.endShow = true;
    },
    // 关闭时间选择器
    cancelStartTime(){
      this.startShow = false;
    },
    cancelEndTime(){
      this.endShow = false;
    }
  }
};
</script>
